import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import { explorePlace } from '../data/data'
import { getSpaceByCountry } from '../services/ApiServices';
import toast from 'react-hot-toast';
import { countryData } from '../utils/UserDataCheckBox';
import processor from '../assets/css/plugins/ajax-loader.gif';

interface Place {
    image: string;
    loction: string;
    property: string;
}

export default function ExplorePropertyOne() {

    const [countryList, setCountryList] = useState<any[]>([]);
    const [isProcessing, setProcessing] = useState<boolean>(false);

    const getSpaceByCountryAPICall = () => {
        setProcessing(true);
        getSpaceByCountry().then((res) => {
            console.log("get property response", res);

            if (res?.status === "success") {
                var countryCountList: any = [];
                explorePlace.forEach((item) => {
                    console.log("countryData", item);

                    var count = res?.data?.find((element: any) => element.continent === item.loction);

                    countryCountList.push({ ...item, property: count?.count ? count?.count : "0" });
                });
                console.log("countryCountList", countryCountList);
                setCountryList(countryCountList);
                setProcessing(false);
            } else {
                setProcessing(false);
                toast.error("Something went wrong")
            }
        })
    }

    useEffect(() => {
        getSpaceByCountryAPICall();
    }, [])

    return (
        <div className="row justify-content-center row-cols-xl-5 row-cols-lg-4 row-cols-md-3 row-cols-sm-2 row-cols-1 g-4">
            {countryList.length === 0 && isProcessing ?
                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 " style={{}}>
                    <div className="fw-bold ms-1 my-0 text-center mt-3" style={{ color: "#AFABAB" }}><img src={processor} width={'10%'} height={'10%'} /></div>
                </div> :
                countryList.map((item: Place, index: number) => {
                    return (
                        <div className="col" key={index}>
                            <div className="position-relative">
                                <Link to="#" className="d-flex align-items-center justify-content-start border rounded-pill p-2">
                                    <div className="explod-thumb flex-shrink-0"><img src={item.image} className="img-fluid circle" width="65" alt="" /></div>
                                    <div className="explod-caps ps-3">
                                        <h5 className="fs-5 fw-medium mb-0">{item.loction}</h5>
                                        <p className="text-muted-2 fs-sm m-0">{parseInt(item.property) <= 1 ? `${item.property} Property` : `${item.property} Properties`}</p>
                                    </div>
                                </Link>
                            </div>
                        </div>
                    )
                })}
        </div>
    )
}
